import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AppService, CoreProxyService, CoreTypes, FormValidatorService, IncidentTypes, LabelValue } from 'common-cloudstudio';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../../services/incident.service';


@Component({
  selector: 'app-incident-lanes',
  templateUrl: './Incident-lanes.component.html',
  styleUrls: ['./Incident-lanes.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentLanesComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentLanesComponent),
      multi: true,
    }
  ]
})

export class IncidentLanesComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor { 
  today = new Date();
  minDateLane = new Date();
  _data: CoreTypes.ITS_IncidentLanes = new CoreTypes.ITS_IncidentLanes();
  @Input('data')
  set data(data: string) {
    this.writeValue(data);
  }
  get data() {
    return JSON.stringify(this._data);
  }
  @Input() editing: boolean = false;
  onChange = (_:any) => { }
  onTouch = () => { }
  isDisabled: boolean;

  @Output() disableForm = new EventEmitter<boolean>();

  _roadwayFullList: CoreTypes.ITS_Roadways[] = [];
  _referenceFullList: CoreTypes.ITS_ReferencePoints[] = [];
  _displayControl: boolean = false;
  _laneRoadwayList: LabelValue<number>[] = [];
  _trafficDirectionsFullList:CoreTypes.ITS_TrafficDirection[] = [];
  _trafficDirectionsList: LabelValue<number>[] = [];
  _laneList: LabelValue<number>[] = [];
  _reasonLaneCloseList: LabelValue<number>[] = [];
  _reasonLaneOpenList: LabelValue<number>[] = [];
  _laneFullList: CoreTypes.ITS_RoadWaysLanes[] = [];
  _movilList: LabelValue<number>[] = [];
  _vialAxesList: LabelValue<number>[] = [];
  _laneErrorMessage: string;
  incidentElementTypes = IncidentTypes.elementTypes;

  dateFrom: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    },
    Time: {
      Hour: this.today.getHours(),
      Minute: this.today.getMinutes(),
      Second: this.today.getSeconds(),
      Millisecond: this.today.getMilliseconds(),
    }
  };

  form: UntypedFormGroup = this.fb.group({
    lanes: [this._laneList[0]],
    laneRoadway: [this._laneRoadwayList[0]],
    vialAxes: [{ value: this._vialAxesList[0], disabled: true}],
    trafficDirections: [this._trafficDirectionsList[0]],
    dateFromlanes: [new CoreTypes.DateTimeDT()],
    dateToLanes: [new CoreTypes.DateTimeDT()],
    startKilometerLane: [null],
    endKilometerLane: [null],
    movil: [this._movilList[0], [Validators.required]],
    reasonLaneClose:[this._reasonLaneCloseList[0]],
    reasonLaneOpen: [this._reasonLaneOpenList[0]]
  });
  _errorBackEnd:string;
  subscriptions: Subscription[] = [];
  loadLanes: number = 0;

  constructor(
    private fb: UntypedFormBuilder,
    public appService: AppService,
    public _formValidatorService: FormValidatorService,
    private incidentService: IncidentService,
    private _coreProxyService: CoreProxyService,
    private cdRef:ChangeDetectorRef,
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  
  public validate() {
    let errors: ValidationErrors = {};
    Object.keys(this.form.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.form.get(key).errors;
      if (controlErrors != null) {
        errors[key] = controlErrors;
      }
    });
    return errors;
  }

  ngOnInit(): void {
    this.getVialAxes();
    this.getITSRoadways();
    this.getAssistenceVehicles();

    this.subscriptions.push(this.trafficDirections.valueChanges.subscribe(value => {
      if(value?.value || value?.value == 0) {
        this._data.DirectionID = value.value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.laneRoadway.valueChanges.subscribe(value => {
      if(value?.value) {
        this._data.RoadwayID = value.value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.lanes.valueChanges.subscribe(value => {
      if(value?.value || value?.value == 0) {
        this._data.LaneID = value.value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.startKilometerLane.valueChanges.subscribe(value => {
      if(value) {
        this._data.StartKilometerPoint = value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.endKilometerLane.valueChanges.subscribe(value => {
      if(value) {
        this._data.EndKilometerPoint = value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.movil.valueChanges.subscribe(value => {
      if(value?.value) {
        this._data.EmergencyVehicleID = value.value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.reasonLaneClose.valueChanges.subscribe(value => {
      if(value?.value) {
        this._data.ClosureReasonID = value.value;
        this.onInput();
      }
    }));

    this.subscriptions.push(this.reasonLaneOpen.valueChanges.subscribe(value => {
      if(value?.value && this.dateToLanes?.value?.Date?.Day) {
        this._data.OpeningReasonID = value.value;
        this.onInput();
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges() {
    this.getAssistenceVehicles();
    this.getITSReasonsClosing();
    this.getITSReasonsOpening();
  }

  onInput() {
    (!this.lanes?.value?.value || !this.trafficDirections?.value?.value) ? this.disableForm.emit(true) : this.disableForm.emit(false);
    this.onTouch();
    this.onChange(JSON.stringify(this._data));
  }

  writeValue(value: any): void {
    this.loadLanes = 1;
    if (value) {
      this._data = JSON.parse(value);
      this.dateFromlanes.setValue(this._data.ClosureStartDateTime);
      this.dateToLanes.setValue(this._data.ClosureEndDateTime);
      this.startKilometerLane.setValue(this._data.StartKilometerPoint);
      this.endKilometerLane.setValue(this._data.EndKilometerPoint);
      if(this.dateFromlanes?.value?.Date?.Day) { this.minDateLane = this.incidentService.setMinDate(this.dateFromlanes?.value); }
    } else {
      this._data = new CoreTypes.ITS_IncidentLanes();
    }
    const laneRoadway = this._data?.RoadwayID ? this._laneRoadwayList.find(s => s.value === this._data?.RoadwayID) : this._laneRoadwayList[0];
    this.laneRoadway.setValue(laneRoadway);
    const lane = this._data?.LaneID ? this._laneList.find(s => s.value === this._data?.LaneID) : this._laneList[0];
    this.lanes.setValue(lane);
    const movil = this._movilList.find(m => m.value === this._data?.EmergencyVehicleID)?? this._movilList[0];
    this.movil.setValue(movil);
    const reasonClose = this._data?.ClosureReasonID ? this._reasonLaneCloseList.find(s => s.value === this._data?.ClosureReasonID) : this._reasonLaneCloseList[0];
    this.reasonLaneClose.setValue(reasonClose);
    const reasonOpen = this._data?.OpeningReasonID ? this._reasonLaneOpenList.find(s => s.value === this._data?.OpeningReasonID) : this._reasonLaneOpenList[0];
    this.reasonLaneOpen.setValue(reasonOpen);
    this.onInput();
  }

  getITSRoadways() {
    this._laneRoadwayList = [];
    this._roadwayFullList = [];
    this.cdRef.detectChanges();
    this.incidentService.getITSRoadways().then(async roadwayList => {
      this._roadwayFullList = roadwayList;
      this._laneRoadwayList = await this.incidentService._roadwaysList.value;
      let laneRoadWay = this._laneRoadwayList.find(i => this._data.RoadwayID === i.value)?? this._laneRoadwayList.find(r => this.incidentService._roadway?.value === r.value) ?? this._laneRoadwayList[0];
      this.laneRoadway.setValue(laneRoadWay);
      this.cdRef.detectChanges();
      setTimeout(async () => { 
        this.onSelectTrafficDirection(this.laneRoadway.value);
      }, 100); 
    });
  }

  async onSelectTrafficDirection(rodwaySelect){
    this._trafficDirectionsList = await this.incidentService.getITSTrafficDirections();
    this._trafficDirectionsFullList = await this.incidentService._trafficDirectionsList.value;
    let items: LabelValue<number>[] = [];
    this._trafficDirectionsFullList.forEach((i) => {
      const item = {
        label: i.Description,
        value: i.DirectionID,
      };
      items.push(item);
    });
    this._trafficDirectionsList = items;
    const trafficDirections = this._trafficDirectionsList.find(t => t.value === this._data?.DirectionID) ?? this._trafficDirectionsList[0];
    this.trafficDirections.setValue(trafficDirections);
    this.getITSLanesByRoadwayID(this.laneRoadway.value, this.trafficDirections?.value?.value)
  }

  onSelectDirection() {
    // let findRoadWay = this._roadwayFullList?.find(axes => axes.DirectionID === this.trafficDirections?.value?.value);
    let findRoadWay = this._roadwayFullList[0]

    let laneRoadWay = this._laneRoadwayList.find(x => x.value === findRoadWay?.RoadwayID);
    if(laneRoadWay)  {
      this.laneRoadway.setValue(laneRoadWay);
      this.onSelectLane(laneRoadWay)
    }
  }

  async onSelectLane(laneRoadway){
    this.onSelectTrafficDirection(laneRoadway); 
  }

  getITSLanesByRoadwayID(rodwaySelect, directionID: number) {
    if(!rodwaySelect?.value) return;
    this.loadLanes = 1;
    return new Promise((resolve, reject) => {
      this._laneFullList = [];
      this._laneList = [];
      this.lanes.setValue(null);
      let laneItems: LabelValue<number>[] = [];
      this.cdRef.detectChanges();
      this._coreProxyService.IncidentService.EnumITSRoadwayLanesByRoadwayID(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        rodwaySelect?.value,
        directionID,
        async data => {
          this._laneFullList = data;
          let lanesList = [];
          if(!data.length) { 
            let lanesFullList = await this.incidentService.getITSLanes();
            if(lanesFullList.length) {
              lanesList = lanesFullList.filter(x => x.RoadwayID == rodwaySelect?.value);
            }
          }

          if(data.length) {
            laneItems.push({
              label: "Desconocido",
              value: 0
            });
          }
          data.forEach((i) => {
            const lane = {
              label: i.LaneName,
              value: i.LaneID,
              disabled: this.disabledItem(i.LaneID)
            }
            if (this._data.LaneID === i.LaneID || laneItems.length === 0) {
              this.lanes.setValue(lane);
              this.cdRef.detectChanges();
            }
            laneItems.push(lane);
          });
          this.loadLanes = 0;
          this._laneList = laneItems;
         
          if(!this._data?.LaneID || (this._data.LaneID && !this.lanes?.value?.value)) this.lanes.setValue(this._laneList[0]);
          resolve(data);
        },
        err => {
          this.appService.showException(err);
          this.loadLanes = 2;
          reject(err);
        }
      );
    })
  };
    
  disabledItem(element: any): boolean {
    return this.incidentService.isItemSelectedInSection(this.incidentElementTypes.Lanes, element);
  }

  getAssistenceVehicles() {
    this._movilList = [];
    let optionsList: LabelValue<number>[] = [];
    this.incidentService._assistanceDispacthList?.forEach(x => {
      if(x.ServiceID || !x.Movil) return;
      let item = { label: x.Movil, value: x.VehicleID };
      optionsList.push(item);
    });
    this._movilList = optionsList;
  }

  getVialAxes() {
    this._vialAxesList = this.incidentService._vialAxesList;
    this.vialAxes.setValue(this.incidentService._vialAxes);
  }
  
  async getITSReasonsClosing() {
    await this.incidentService.getITSReasonsClosing();
    this._reasonLaneCloseList = await this.incidentService._reasonCloseList.value;
    const reasonClose = this._data?.ClosureReasonID ? this._reasonLaneCloseList.find(s => s.value === this._data?.ClosureReasonID) : this._reasonLaneCloseList[0];
    this.reasonLaneClose.setValue(reasonClose);
  }

  async getITSReasonsOpening() {
    await this.incidentService.getITSReasonsOpening();
    this._reasonLaneOpenList = await this.incidentService._reasonOpenList.value;
    const reasonOpen = this._data?.OpeningReasonID ? this._reasonLaneOpenList.find(s => s.value === this._data?.OpeningReasonID) : this._reasonLaneOpenList[0];
    this.reasonLaneOpen.setValue(reasonOpen);
  }

  applyFilters(controlName?) {
    if(this.dateFromlanes?.value?.Date?.Day) { this.minDateLane = this.incidentService.setMinDate(this.dateFromlanes?.value); }
    if(controlName === "dateFromlanes") { this._data.ClosureStartDateTime = this.dateFromlanes.value; }
    if(controlName === "dateToLanes") { 
      this._data.ClosureEndDateTime = this.dateToLanes.value; 
      this.cdRef.detectChanges(); 
    }
    setTimeout(() => this.onInput(), 100); 
  }
  
  updateMaxDate() {
    this.today = new Date();
  }

  get vialAxes() { return this.form.get('vialAxes'); }
  get laneRoadway() { return this.form.get('laneRoadway'); }
  get lanes() { return this.form.get('lanes'); }
  get trafficDirections() { return this.form.get('trafficDirections'); }
  get dateFromlanes() { return this.form.get('dateFromlanes'); }
  get dateToLanes() { return this.form.get('dateToLanes'); }
  get startKilometerLane() { return this.form.get('startKilometerLane'); }
  get endKilometerLane() { return this.form.get('endKilometerLane'); }
  get movil() { return this.form.get('movil'); }
  get reasonLaneClose() { return this.form.get('reasonLaneClose'); }
  get reasonLaneOpen() { return this.form.get('reasonLaneOpen'); }

}
